/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "timecards": {
        "nested": {
          "LocalDateTime": {
            "fields": {
              "localDate": {
                "type": "squareup.common.time.YearMonthDay",
                "id": 1,
                "rule": "optional"
              },
              "localTime": {
                "type": "squareup.common.time.LocalTime",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "LocalDateTimeRange": {
            "fields": {
              "start": {
                "type": "squareup.timecards.LocalDateTime",
                "id": 1,
                "rule": "optional"
              },
              "stop": {
                "type": "squareup.timecards.LocalDateTime",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "InstantRange": {
            "fields": {
              "startEpochMillisecond": {
                "type": "uint64",
                "id": 1,
                "rule": "optional"
              },
              "stopEpochMillisecond": {
                "type": "uint64",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "LocalDateRange": {
            "fields": {
              "start": {
                "type": "squareup.common.time.YearMonthDay",
                "id": 1,
                "rule": "optional"
              },
              "stop": {
                "type": "squareup.common.time.YearMonthDay",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.timecards?.nested?.LocalDateTime && !$root.nested?.squareup?.nested?.timecards?.nested?.LocalDateTimeRange && !$root.nested?.squareup?.nested?.timecards?.nested?.InstantRange && !$root.nested?.squareup?.nested?.timecards?.nested?.LocalDateRange) {
  $root.addJSON(jsonData);
}

/**
 * A date and time without a timezone. Equivalent to Java's time.LocalDateTime
 *
 * Time portion has millisecond precision.
 *
 * SOURCE LocalDateTime @ squareup/timecards/time.proto at 23:1
 */
export const LocalDateTime = $root.lookupType('squareup.timecards.LocalDateTime');
fixType(LocalDateTime, {
  localDate: {
    required: true
  },
  localTime: {
    required: true
  }
});
Builder.createAndAttachToType(LocalDateTime);
/**
 * Range for two times without a timezone.
 * Start is inclusive, stop is exclusive. For example, the range of
 * 2015-01-15 12:00am to 2015-01-18 12:00am is equivalent to the time range of
 * 2015-01-15 12:00am to 2015-01-17 11:59:59.99999... pm
 *
 * SOURCE LocalDateTimeRange @ squareup/timecards/time.proto at 34:1
 */
export const LocalDateTimeRange = $root.lookupType('squareup.timecards.LocalDateTimeRange');
fixType(LocalDateTimeRange, {
  start: {
    required: true
  },
  stop: {
    required: true
  }
});
Builder.createAndAttachToType(LocalDateTimeRange);
/**
 * Two fixed points on the timeline
 *
 * SOURCE InstantRange @ squareup/timecards/time.proto at 42:1
 */
export const InstantRange = $root.lookupType('squareup.timecards.InstantRange');
fixType(InstantRange, {
  startEpochMillisecond: {
    required: true
  },
  stopEpochMillisecond: {
    required: true
  }
});
Builder.createAndAttachToType(InstantRange);
/**
 * Two dates between `start_date` @ 12:00am to `stop_date` @ 11:59:59:99999 pm.
 *
 * Both start and stop are inclusive. The date range of 2015-01-15 to 2015-01-17
 * is equivalent to the time range of 2015-01-15 12:00 am to 2015-01-17 11:59:59:99999... pm.
 *
 * SOURCE LocalDateRange @ squareup/timecards/time.proto at 53:1
 */
export const LocalDateRange = $root.lookupType('squareup.timecards.LocalDateRange');
fixType(LocalDateRange, {
  start: {
    required: true
  },
  stop: {
    required: true
  }
});
Builder.createAndAttachToType(LocalDateRange);